import { DEFAULT_LOCATION_DISTANCE_METERS } from '@bts/shared'
import { useContext } from 'react'
import type { GameType } from '../contexts/GameContext'
import GameContext from '../contexts/GameContext'
import type { GetGameDetailsBySlugQuery } from '../generated/graphql'
import { HelpWidget, useGetGameDetailsBySlugQuery } from '../generated/graphql'

export type GameDetailsType =
  GetGameDetailsBySlugQuery['getGameBySlug'] | undefined

const DEFAULT_TIMEZONE = 'Europe/London'
const DEFAULT_MIN_SWIPE_TIME_MINUTES = 1

const getRouteGameFallback = (routeGame: GameType): GameDetailsType => {
  if (!routeGame) return undefined

  return {
    id: routeGame.id,
    info: {
      ...routeGame.info,
      anticipationStartsAt: '',
      teamsStartsAt: '',
      startsAt: '',
      endsAt: '',
      sustainEndsAt: '',
      helpWidget: HelpWidget.Standard,
      settings: {
        minSwipeTime: DEFAULT_MIN_SWIPE_TIME_MINUTES,
        timezone: DEFAULT_TIMEZONE,
        target: 0,
        targetZones: [],
        locationDistanceMeters: DEFAULT_LOCATION_DISTANCE_METERS,
      },
      targetedEmails: {
        gameCountdown: false,
        noActivity: false,
        stoppedPlaying: false,
      },
    },
    liveTotals: {
      everJoinedPlayers: 0,
      registeredPlayers: 0,
      totalMiles: 0,
      totalPlayers: 0,
    },
  } as GameDetailsType
}

const useGame = (): GameDetailsType => {
  const routeGame = useContext(GameContext)
  const slug = routeGame?.info.slug
  const { data } = useGetGameDetailsBySlugQuery(
    { slug: slug || '' },
    { enabled: Boolean(slug) }
  )

  return data?.getGameBySlug || getRouteGameFallback(routeGame)
}

export default useGame
